<template>
  <FlexCol gap-1>
    <Label label="Arquivo" />
    <InputArc>
      <template #input>
        <Flex items-center>
          <a
            v-if="url"
            target="_blank"
            class="text-blue-500 cursor-pointer hover:text-blue-700"
            :href="`${baseApiUrl}/uploads/${url}`"
            >{{ url }}</a
          >
        </Flex>
      </template>
    </InputArc>
  </FlexCol>
</template>

<script setup>
import { baseApiUrl } from '@/global'

const props = defineProps({
  url: String,
})
</script>
